module.exports = __webpack_public_path__ + "assets/Retina-Bold.5d1041fbec394f70a14495c5cd270344.woff2";